import { getBaseApiUrl } from "./../env";
import BaseAPI from "./baseAPI";

const getMaterialUrl = (m_id) => `${getBaseApiUrl()}/quiz/material/${m_id}/`;
const getGenMaterialUrl = () => `${getBaseApiUrl()}/quiz/material/generate`;
const getCreateMaterialUrl = () => `${getBaseApiUrl()}/quiz/material/create`;
const getEditMaterialUrl = (m_id) => `${getBaseApiUrl()}/quiz/material/edit/${m_id}/`;


class API extends BaseAPI {
  constructor(props) {
    super(props);
    this.props = props;
  }

  get = ({ id }) => {
      return this.fetchSecure({ url: getMaterialUrl(id) });
  };

  post = ({ id, data }) => {
    if (data.is_edit)
    {
      return this.postSecure({ url: getEditMaterialUrl(id), data });
    }
  };
  getformdata = () => {
    return this.fetchSecure({ url: `${getBaseApiUrl()}/quiz/material/generate/custom` });
  };
  
  postformdata = ({data}) => {
    if (data.is_create)
    {
      return this.postSecure({ url: getCreateMaterialUrl(), data });
    }
    else{
      return this.postSecure({ url: getGenMaterialUrl(), data });
    }
  };
}

export default new API();
